import { render } from "./EditDepotDrawer.vue?vue&type=template&id=5d366926"
import script from "./EditDepotDrawer.vue?vue&type=script&lang=js"
export * from "./EditDepotDrawer.vue?vue&type=script&lang=js"

import "./EditDepotDrawer.vue?vue&type=style&index=0&id=5d366926&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__